import { Box } from "@mui/material";
import { ImagemLogo, ListOption, Options, TopBar} from "./styles";

import OptionsMenu from "../optionsMenu";

import React, {useEffect} from "react";
import {useSideBarContext} from "../../contexts/drawer-context";
import MenuIcon from "../menu-icon";
import { FaBuilding, FaUserAlt } from "react-icons/fa";
import { TiHome } from "react-icons/ti";

export default function NavbarLayout() {

  const { setSideBarOption } = useSideBarContext();
  const { sideBarOption } = useSideBarContext();

  useEffect(() => {
    setSideBarOption([
      {
        label: "Início",
        path: "/dashboard",
        icon: <TiHome size={16} color="#fff" />
      },
      {
        label: "Usuários",
        path: "/usuarios/listar",
        icon: <div style={{marginBottom: 3}}><FaUserAlt size={12} color="#fff" /></div>
      },
      {
        label: "Ambientes",
        path: "/environments/listar",
        icon: <div style={{marginBottom: 3}}><FaBuilding size={12} color="#fff" /></div>
      },
    ]);
  }, []);

  return (
    <Box>
      <TopBar>
        <Options>
          <ImagemLogo/>
          <ListOption >
            {sideBarOption.map((drawerOption) => (
              <OptionsMenu
                path={drawerOption.path}
                key={drawerOption.path}
                label={drawerOption.label}
                icon={drawerOption.icon}
              />
            ))}
          </ListOption>
          <MenuIcon/>
        </Options>
      </TopBar>
    </Box>
  );
}
